import { fg } from '@atlassian/jira-feature-gating';

const lastUsedJql = {
	get(): boolean {
		return fg('jira_nin_last_used_jql');
	},
};

export default lastUsedJql;
